<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content examplex text-center">
            <vs-tooltip text="Tooltip Default">
              <vs-switch v-model="switch1" />
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip text="Tooltip Default">
              <vs-input-number v-model="number1" />
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip text="Tooltip Default">
              <vs-button color="primary" type="border">Button</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Position</h6>
            </div>
          </header>
          <div class="vs-card--content examplex">
            <vs-tooltip text="Tooltip position Left" position="left">
              <vs-button type="gradient">Left</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip text="Tooltip position Top" position="top">
              <vs-button type="gradient">Top</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip text="Tooltip position Bottom" position="bottom">
              <vs-button type="gradient">Bottom</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip text="Tooltip position Right" position="right">
              <vs-button type="gradient">Right</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Delay</h6>
            </div>
          </header>
          <div class="vs-card--content examplex">
            <vs-tooltip text="Tooltip default delay">
              <vs-button>Delay default</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip delay=".5s" text="Tooltip delay 0.5s">
              <vs-button>Delay 0.5s</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip delay="2s" text="Tooltip delay 2s">
              <vs-button>Delay 2s</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Color</h6>
            </div>
          </header>
          <div class="vs-card--content examplex block sm:flex">
            <vs-tooltip class="m-2" text="Tooltip default delay">
              <vs-button type="gradient">Default Color</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip class="m-2"  color="primary" text="Tooltip default delay">
              <vs-button type="border">Color primary</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip class="m-2"  color="success" text="Tooltip default delay">
              <vs-button color="success" type="border">Color success</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip class="m-2"  color="danger" text="Tooltip default delay">
              <vs-button color="danger" type="border">Color danger</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip class="m-2"  color="warning" text="Tooltip default delay">
              <vs-button color="warning" type="border">Color warning</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip class="m-2"  color="dark" text="Tooltip default delay">
              <vs-button color="dark" type="border">Color dark</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip class="m-2"  color="rgb(42, 207, 133)" text="Tooltip default delay">
              <vs-button color="rgb(42, 207, 133)" type="border"
                >Color RGB</vs-button
              >
              <span>&nbsp;</span></vs-tooltip
            >
            <vs-tooltip class="m-2"  color="#4a0d6b" text="Tooltip default delay">
              <vs-button color="#4a0d6b" type="border">Color HEX</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Title</h6>
            </div>
          </header>
          <div class="vs-card--content examplex">
            <vs-tooltip
              title="Are you sure?"
              color="warning"
              text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras scelerisque non neque sed aliquet."
            >
              <vs-button color="warning" type="flat">Title Tooltip</vs-button>
              <span>&nbsp;</span></vs-tooltip
            >
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({
    switch1: true,
    number1: 10,
  }),
};
</script>
